import { useRef } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../i18n/LanguageContext';
import { appendTrackingParams } from '../../utils/utm';

export default function Hero() {
  const { t } = useLanguage();
  const videoRef = useRef(null);

  return (
    <section className="relative h-[100vh] w-full overflow-hidden bg-black" data-testid="hero-section">
      {/* Video background */}
      <video
        ref={videoRef}
        className="absolute inset-0 w-full h-full object-cover"
        src="/assets/video/hero.mp4"
        poster="/assets/video/hero-poster.jpg"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        data-testid="hero-video"
      />
      {/* Subtle dark overlay for legibility */}
      <div className="absolute inset-0 bg-black/30" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/50" />

      {/* Content */}
      <div className="relative h-full flex flex-col items-center justify-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="text-center">
          <h1
            className="select-none flex justify-center"
            data-testid="hero-wordmark">
            <img src="/assets/evern-logo.png" alt="evern" className="w-auto" style={{ height: 'clamp(2.5rem, 6.5vw, 5rem)' }} />
          </h1>
          <p
            className="mt-4 md:mt-6 font-body font-light text-white/90 lowercase tracking-wide"
            style={{ fontSize: 'clamp(0.9rem, 1.6vw, 1.25rem)' }}
            data-testid="hero-tagline">
            {t.hero_tagline}
          </p>

          <motion.a
            href={appendTrackingParams(t.hero_cta_url)}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.5 }}
            className="mt-10 md:mt-14 inline-flex items-center justify-center px-10 py-4 bg-ev-lime hover:bg-ev-lime-dim text-ev-ink font-body font-medium text-base rounded-full transition-colors lowercase tracking-wide"
            data-testid="hero-cta">
            {t.hero_cta}
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
}
